import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app-config.loader';
import { AuditSearchRequest, AuditSearchResponse } from '../shared/models/audit.model';

@Injectable({
  providedIn: 'root'
})
export class AuditService {
  private apiBaseUrl: string;

  constructor(private appConfig: AppConfig, private http: HttpClient) {
    this.apiBaseUrl = this.appConfig.settings.apiRoot;
  }

  public search(filters: AuditSearchRequest): Observable<AuditSearchResponse> {
    return this.http.post<AuditSearchResponse>(`${this.apiBaseUrl}/Audit/Search/`, filters);
  }
}
